﻿import {
  OperationType,
  ProjectResourceType,
  RoleSigningStatusDto,
} from 'services/api/api-client.types.ts';
import styles from './MultipleSigningRoleIcon.module.scss';
import iconStyles from './IconStyles.module.scss';
import { FC } from 'react';
import clsx from 'clsx';
import { getStyleFromStatus, getTextFromStatus } from './helpers.ts';
import { createId } from 'components/uikit/type-utils.ts';
import { BrightTooltip } from 'components/tooltips/BrightTooltip.tsx';
import RemoveIcon from 'assets/icons/remove.svg?react';
import { PermissionTextButton } from 'helpers/projectPermissions/components/PermissionTextButton.tsx';
import { permission } from 'helpers/projectPermissions/types/projectPermission.ts';

export type MultipleSigningRoleIconProps = {
  dtos: RoleSigningStatusDto[];
  onRemove: (roleId: number) => void;
};

export const MultipleSigningRoleIcon: FC<MultipleSigningRoleIconProps> = (
  props,
) => {
  return (
    <BrightTooltip
      key={createId()}
      title={
        <MultipleSigningRoleTooltip
          dtos={props.dtos}
          onRemove={props.onRemove}
        />
      }
      leaveDelay={150}
      placement="bottom"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -10],
            },
          },
        ],
      }}
    >
      <div className={iconStyles.icon}>+{props.dtos.length}</div>
    </BrightTooltip>
  );
};

type MultipleSigningRoleProps = {
  dtos: RoleSigningStatusDto[];
  onRemove: (roleId: number) => void;
};

const MultipleSigningRoleTooltip: FC<MultipleSigningRoleProps> = (props) => {
  return (
    <div className={styles.tooltip}>
      {props.dtos.map((dto) => (
        <div className={styles.tooltipBlock}>
          <div className={styles.tooltipTitle}>{dto.role.name}</div>
          {dto.isDeletable && (
            <PermissionTextButton
              testId={'delete-button'}
              icon={<RemoveIcon />}
              className={styles.deleteButton}
              onClick={() => props.onRemove(dto.role.id)}
              permissions={[
                permission(
                  ProjectResourceType.ProjectRole,
                  OperationType.Update,
                ),
                permission(ProjectResourceType.Document, OperationType.Update),
              ]}
            />
          )}
          <div className={styles.tooltipItems}>
            {dto.role.signers?.map((e) => (
              <div className={styles.tooltipItem}>
                {e.signer.firstName} {e.signer.lastName}
              </div>
            ))}
          </div>
          <div
            className={clsx(
              getStyleFromStatus(dto.status, false),
              styles.tooltipComment,
            )}
          >
            {getTextFromStatus(dto.status)}
          </div>
        </div>
      ))}
    </div>
  );
};
